// src/data/products/msFlatPatti.js
import flatPattiImg from '../../assets/images/ms-flat-patti.jpg';

export const msFlatPattiData = {
  slug: 'ms-flat-patti',
  name: 'MS Flat Patti',
  image: flatPattiImg,
  description: 'High-quality MS flat bars for construction and fabrication applications.',
  subcategories: [
    {
      slug: 'standard-flat-bars',
      name: 'Standard Flat Bars',
      description: 'Standard MS flat bars for general construction and fabrication.',
      image: flatPattiImg,
      products: [
        {
          slug: 'ms-flat-20x3',
          name: 'MS Flat 20x3mm',
          image: flatPattiImg,
          shortDesc: 'Standard 20x3mm MS flat bar for light fabrication.',
          description: 'MS Flat 20x3mm is ideal for light fabrication work, frames, and general construction applications. Manufactured with excellent dimensional accuracy.',
          dimensions: [
            { size: '20x3mm', weight: '0.471 kg/m', length: '6m', price: 'Price on Request' },
            { size: '20x3mm', weight: '0.471 kg/m', length: '12m', price: 'Price on Request' },
          ],
          specifications: [
            { property: 'Material', value: 'MS (IS 2062)' },
            { property: 'Surface', value: 'Black/Bright' },
            { property: 'Tensile Strength', value: '410-540 N/mm²' },
            { property: 'Yield Strength', value: 'Min. 250 N/mm²' }
          ],
          terms: [
            'Prices are subject to change based on market conditions without prior notice.',
            'GST and other applicable taxes are extra.',
            'Loading charges will be borne by the buyer.',
            'Advance payment is required before dispatch of goods.',
            'All sales are subject to our standard terms and conditions.'
          ]
        },
        {
          slug: 'ms-flat-25x3',
          name: 'MS Flat 25x3mm',
          image: flatPattiImg,
          shortDesc: 'Standard 25x3mm MS flat bar for medium fabrication.',
          description: 'MS Flat 25x3mm provides good strength for medium fabrication work and structural applications. Excellent weldability and machinability.',
          dimensions: [
            { size: '25x3mm', weight: '0.589 kg/m', length: '6m', price: 'Price on Request' },
            { size: '25x3mm', weight: '0.589 kg/m', length: '12m', price: 'Price on Request' },
          ],
          specifications: [
            { property: 'Material', value: 'MS (IS 2062)' },
            { property: 'Surface', value: 'Black/Bright' },
            { property: 'Tensile Strength', value: '410-540 N/mm²' },
            { property: 'Yield Strength', value: 'Min. 250 N/mm²' }
          ],
          terms: [
            'Prices are subject to change based on market conditions without prior notice.',
            'GST and other applicable taxes are extra.',
            'Loading charges will be borne by the buyer.',
            'Advance payment is required before dispatch of goods.',
            'All sales are subject to our standard terms and conditions.'
          ]
        },
        {
          slug: 'ms-flat-40x5',
          name: 'MS Flat 40x5mm',
          image: flatPattiImg,
          shortDesc: 'Heavy-duty 40x5mm MS flat bar for structural work.',
          description: 'MS Flat 40x5mm is designed for heavy-duty applications requiring higher strength and load-bearing capacity. Ideal for structural fabrication.',
          dimensions: [
            { size: '40x5mm', weight: '1.570 kg/m', length: '6m', price: 'Price on Request' },
            { size: '40x5mm', weight: '1.570 kg/m', length: '12m', price: 'Price on Request' },
          ],
          specifications: [
            { property: 'Material', value: 'MS (IS 2062)' },
            { property: 'Surface', value: 'Black/Bright' },
            { property: 'Tensile Strength', value: '410-540 N/mm²' },
            { property: 'Yield Strength', value: 'Min. 250 N/mm²' }
          ],
          terms: [
            'Prices are subject to change based on market conditions without prior notice.',
            'GST and other applicable taxes are extra.',
            'Loading charges will be borne by the buyer.',
            'Advance payment is required before dispatch of goods.',
            'All sales are subject to our standard terms and conditions.'
          ]
        },
        {
          slug: 'ms-flat-50x6',
          name: 'MS Flat 50x6mm',
          image: flatPattiImg,
          shortDesc: 'Heavy-duty 50x6mm MS flat bar for industrial applications.',
          description: 'MS Flat 50x6mm offers excellent strength for industrial and heavy construction applications. Perfect for frames, supports, and structural elements.',
          dimensions: [
            { size: '50x6mm', weight: '2.355 kg/m', length: '6m', price: 'Price on Request' },
            { size: '50x6mm', weight: '2.355 kg/m', length: '12m', price: 'Price on Request' },
          ],
          specifications: [
            { property: 'Material', value: 'MS (IS 2062)' },
            { property: 'Surface', value: 'Black/Bright' },
            { property: 'Tensile Strength', value: '410-540 N/mm²' },
            { property: 'Yield Strength', value: 'Min. 250 N/mm²' }
          ],
          terms: [
            'Prices are subject to change based on market conditions without prior notice.',
            'GST and other applicable taxes are extra.',
            'Loading charges will be borne by the buyer.',
            'Advance payment is required before dispatch of goods.',
            'All sales are subject to our standard terms and conditions.'
          ]
        },
        {
          slug: 'ms-flat-75x6',
          name: 'MS Flat 75x6mm',
          image: flatPattiImg,
          shortDesc: 'Extra heavy-duty 75x6mm MS flat bar for demanding applications.',
          description: 'MS Flat 75x6mm provides maximum strength for the most demanding structural and industrial applications. Excellent for heavy-duty fabrication work.',
          dimensions: [
            { size: '75x6mm', weight: '3.533 kg/m', length: '6m', price: 'Price on Request' },
            { size: '75x6mm', weight: '3.533 kg/m', length: '12m', price: 'Price on Request' },
          ],
          specifications: [
            { property: 'Material', value: 'MS (IS 2062)' },
            { property: 'Surface', value: 'Black/Bright' },
            { property: 'Tensile Strength', value: '410-540 N/mm²' },
            { property: 'Yield Strength', value: 'Min. 250 N/mm²' }
          ],
          terms: [
            'Prices are subject to change based on market conditions without prior notice.',
            'GST and other applicable taxes are extra.',
            'Loading charges will be borne by the buyer.',
            'Advance payment is required before dispatch of goods.',
            'All sales are subject to our standard terms and conditions.'
          ]
        }
      ]
    },
    {
      slug: 'custom-flat-bars',
      name: 'Custom Flat Bars',
      description: 'Custom-sized MS flat bars for specific applications.',
      image: flatPattiImg,
      products: [
        {
          slug: 'ms-flat-custom',
          name: 'MS Flat Custom Size',
          image: flatPattiImg,
          shortDesc: 'Custom-sized MS flat bars as per customer requirements.',
          description: 'Custom MS Flat bars manufactured to specific dimensions as per customer requirements. Available in various widths and thicknesses for specialized applications.',
          dimensions: [
            { size: 'Custom Width', thickness: 'Custom Thickness', length: 'As Required', price: 'Price on Request' },
            { size: 'Up to 200mm Width', thickness: 'Up to 25mm Thick', length: '6m/12m', price: 'Price on Request' },
          ],
          specifications: [
            { property: 'Material', value: 'MS (IS 2062)' },
            { property: 'Surface', value: 'Black/Bright' },
            { property: 'Tensile Strength', value: '410-540 N/mm²' },
            { property: 'Yield Strength', value: 'Min. 250 N/mm²' },
            { property: 'Tolerance', value: 'As per IS 1730' }
          ],
          terms: [
            'Prices are subject to change based on market conditions without prior notice.',
            'GST and other applicable taxes are extra.',
            'Loading charges will be borne by the buyer.',
            'Advance payment is required before dispatch of goods.',
            'All sales are subject to our standard terms and conditions.',
            'Minimum order quantities may apply for custom sizes.'
          ]
        }
      ]
    }
  ]
};
